export default __webpack_public_path__ + "day-stork-bg-1366x768.4434a04.svg";